import type { ObjectState, ObjectStateType, StateSupportedObject } from '@playbooks/action-cards-utils/src'

/**
 * Service for manage object states.
 */
export default class StateManager {
  public static get<T extends ObjectState>(obj: StateSupportedObject, name: string): T | null {
    return (obj.states?.find(state => state.type == name) as T) || null
  }

  public static getOrCreate<T extends ObjectState>(obj: StateSupportedObject, type: ObjectStateType): T {
    let state = StateManager.get<ObjectState>(obj, type)

    if (!state) {
      state = {
        type: type,
        isActive: false,
        activeTags: [],
        inactiveTags: [],
      }
      obj.states = obj.states || []
      obj.states.push(state)
    }

    return state as T
  }

  public static areStatesEqual(arr1: ObjectState[], arr2: ObjectState[]): boolean {
    if (arr1.length !== arr2.length) {
      return false
    }

    const sortedArr1 = arr1.slice().sort((a, b) => a.type?.localeCompare(b.type) || -1)
    const sortedArr2 = arr2.slice().sort((a, b) => a.type?.localeCompare(b.type) || -1)

    return sortedArr1.every(
      (state, index) => state.type === sortedArr2[index].type && state.isActive === sortedArr2[index].isActive,
    )
  }
}
